"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __copyProps = (to, from, except, desc) => {
	if (from && typeof from === "object" || typeof from === "function") {
		for (let key of __getOwnPropNames(from)) if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
			get: () => from[key],
			enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
		});
	}
	return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
	// If the importer is in node compatibility mode or this is not an ESM
	// file that has been converted to a CommonJS file using a Babel-
	// compatible transform (i.e. "__esModule" has not been set), then set
	// "default" to the CommonJS "module.exports" for node compatibility.
	isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", {
		value: mod,
		enumerable: true
	}) : target,
	mod
));
var import_jsx_runtime = require("react/jsx-runtime");
var import_react = __toESM(require("react"), 1);
var import_react_test_renderer = __toESM(require("react-test-renderer"), 1);
var import_vitest = require("vitest");
var import_useScreens = require("./useScreens");
var pendingRoute = new Promise(function() {});
var previousTarget = "native";
var previousSuspendRoutesNative = process.env.ONE_SUSPEND_ROUTES_NATIVE;
var previousDisableSuspense = globalThis.__ONE_DISABLE_SUSPENSE_ROUTES__;
function createRouteNode(type, route, contextKey, loadRoute) {
	return {
		type,
		route,
		contextKey,
		loadRoute,
		children: [],
		dynamic: null
	};
}
function SuspendingRoute() {
	throw pendingRoute;
}
(0, import_vitest.beforeEach)(function() {
	process.env.TAMAGUI_TARGET = "native";
	delete process.env.ONE_SUSPEND_ROUTES_NATIVE;
	delete globalThis.__ONE_DISABLE_SUSPENSE_ROUTES__;
});
(0, import_vitest.afterEach)(function() {
	if (previousTarget === void 0) delete "native";
	else process.env.TAMAGUI_TARGET = previousTarget;
	if (previousSuspendRoutesNative === void 0) delete process.env.ONE_SUSPEND_ROUTES_NATIVE;
	else process.env.ONE_SUSPEND_ROUTES_NATIVE = previousSuspendRoutesNative;
	if (previousDisableSuspense === void 0) delete globalThis.__ONE_DISABLE_SUSPENSE_ROUTES__;
	else globalThis.__ONE_DISABLE_SUSPENSE_ROUTES__ = previousDisableSuspense;
});
(0, import_vitest.describe)("route SuspenseFallback", function() {
	(0, import_vitest.it)("inherits the layout fallback and passes the suspended route details", async function() {
		var childNode = createRouteNode("spa", "profile/[id]", "./(app)/profile/[id].tsx", function() {
			throw pendingRoute;
		});
		var ChildRoute = (0, import_useScreens.getQualifiedRouteComponent)(childNode);
		var layoutNode = createRouteNode("layout", "(app)", "./(app)/_layout.tsx", function() {
			return {
				default: function() {
					return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ChildRoute, { route: { params: { id: "123" } } });
				},
				SuspenseFallback: function(param) {
					var { route, params } = param;
					return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)("div", {
						"data-fallback": "layout",
						children: [
							route,
							":",
							params.id
						]
					});
				}
			};
		});
		var LayoutRoute = (0, import_useScreens.getQualifiedRouteComponent)(layoutNode);
		var renderer;
		await (0, import_react_test_renderer.act)(async function() {
			renderer = import_react_test_renderer.default.create(/* @__PURE__ */ (0, import_jsx_runtime.jsx)(LayoutRoute, {}));
		});
		(0, import_vitest.expect)(renderer.root.findByProps({ "data-fallback": "layout" }).children).toEqual([
			"./(app)/profile/[id].tsx",
			":",
			"123"
		]);
	});
	(0, import_vitest.it)("uses the nearest layout fallback", async function() {
		var childNode = createRouteNode("spa", "profile", "./(app)/profile.tsx", function() {
			return { default: SuspendingRoute };
		});
		var ChildRoute = (0, import_useScreens.getQualifiedRouteComponent)(childNode);
		var nestedLayoutNode = createRouteNode("layout", "(app)", "./(app)/_layout.tsx", function() {
			return {
				default: function() {
					return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ChildRoute, {});
				},
				SuspenseFallback: function() {
					return /* @__PURE__ */ (0, import_jsx_runtime.jsx)("div", { "data-fallback": "nested" });
				}
			};
		});
		var NestedLayoutRoute = (0, import_useScreens.getQualifiedRouteComponent)(nestedLayoutNode);
		var rootLayoutNode = createRouteNode("layout", "", "./_layout.tsx", function() {
			return {
				default: function() {
					return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(NestedLayoutRoute, {});
				},
				SuspenseFallback: function() {
					return /* @__PURE__ */ (0, import_jsx_runtime.jsx)("div", { "data-fallback": "root" });
				}
			};
		});
		var RootLayoutRoute = (0, import_useScreens.getQualifiedRouteComponent)(rootLayoutNode);
		var renderer;
		await (0, import_react_test_renderer.act)(async function() {
			renderer = import_react_test_renderer.default.create(/* @__PURE__ */ (0, import_jsx_runtime.jsx)(RootLayoutRoute, {}));
		});
		(0, import_vitest.expect)(renderer.root.findAllByProps({ "data-fallback": "nested" })).toHaveLength(1);
		(0, import_vitest.expect)(renderer.root.findAllByProps({ "data-fallback": "root" })).toHaveLength(0);
	});
	(0, import_vitest.it)("ignores a SuspenseFallback exported from a leaf route", async function() {
		var childNode = createRouteNode("spa", "profile", "./profile.tsx", function() {
			return {
				default: SuspendingRoute,
				SuspenseFallback: function() {
					return /* @__PURE__ */ (0, import_jsx_runtime.jsx)("div", { "data-fallback": "leaf" });
				}
			};
		});
		var ChildRoute = (0, import_useScreens.getQualifiedRouteComponent)(childNode);
		var renderer;
		await (0, import_react_test_renderer.act)(async function() {
			renderer = import_react_test_renderer.default.create(/* @__PURE__ */ (0, import_jsx_runtime.jsx)(ChildRoute, {}));
		});
		(0, import_vitest.expect)(renderer.root.findAllByProps({ "data-fallback": "leaf" })).toHaveLength(0);
		(0, import_vitest.expect)(renderer.toJSON()).toBeNull();
	});
});
(0, import_vitest.describe)("ErrorBoundary route identity", function() {
	(0, import_vitest.it)("preserves page state across a re-render when the route exports ErrorBoundary", async function() {
		var mounts = 0;
		function Page() {
			var [count, setCount] = import_react.default.useState(0);
			import_react.default.useEffect(function() {
				mounts += 1;
			}, []);
			return /* @__PURE__ */ (0, import_jsx_runtime.jsx)("button", {
				"data-count": count,
				onClick: function() {
					return setCount(function(value) {
						return value + 1;
					});
				},
				children: count
			});
		}
		function ErrorBoundary() {
			return /* @__PURE__ */ (0, import_jsx_runtime.jsx)("div", { "data-error": "1" });
		}
		var node = createRouteNode("spa", "onboarding", "./auth/onboarding.tsx", function() {
			return {
				default: Page,
				ErrorBoundary
			};
		});
		var Route = (0, import_useScreens.getQualifiedRouteComponent)(node);
		function Harness(param) {
			var { tick } = param;
			return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Route, { tick });
		}
		var renderer;
		await (0, import_react_test_renderer.act)(async function() {
			renderer = import_react_test_renderer.default.create(/* @__PURE__ */ (0, import_jsx_runtime.jsx)(Harness, { tick: 0 }));
		});
		var button = renderer.root.findByType("button");
		(0, import_vitest.expect)(button.props["data-count"]).toBe(0);
		await (0, import_react_test_renderer.act)(async function() {
			button.props.onClick();
		});
		(0, import_vitest.expect)(renderer.root.findByType("button").props["data-count"]).toBe(1);
		(0, import_vitest.expect)(mounts).toBe(1);
		await (0, import_react_test_renderer.act)(async function() {
			renderer.update(/* @__PURE__ */ (0, import_jsx_runtime.jsx)(Harness, { tick: 1 }));
		});
		(0, import_vitest.expect)(renderer.root.findByType("button").props["data-count"]).toBe(1);
		(0, import_vitest.expect)(mounts).toBe(1);
	});
	(0, import_vitest.it)("still renders the exported ErrorBoundary when the page throws", async function() {
		function Page() {
			throw new Error("boom");
		}
		function ErrorBoundary(param) {
			var { error } = param;
			return /* @__PURE__ */ (0, import_jsx_runtime.jsx)("div", { "data-caught": error.message });
		}
		var node = createRouteNode("spa", "broken", "./broken.tsx", function() {
			return {
				default: Page,
				ErrorBoundary
			};
		});
		var Route = (0, import_useScreens.getQualifiedRouteComponent)(node);
		var renderer;
		await (0, import_react_test_renderer.act)(async function() {
			renderer = import_react_test_renderer.default.create(/* @__PURE__ */ (0, import_jsx_runtime.jsx)(Route, {}));
		});
		(0, import_vitest.expect)(renderer.root.findByProps({ "data-caught": "boom" })).toBeTruthy();
	});
});
//# sourceMappingURL=useScreens.test.js.map
